<template>
<div>

    <div class="row" v-if="!mode">
        <div class="col-3">
            <v-img :src="previewPicture" />
        </div>
        <div class="col-9">
            <v-file-input outlined v-model="pictureUpload" id="file" ref="file" :label="label ? label : 'รูปภาพ'" filled prepend-icon="mdi-image" accept=".jpg,.jpeg"></v-file-input>
            <div class="mt-2 mb-2 uploadResult" v-if="uploadResult" v-html="uploadResult"></div>
            <div class="text-center" v-if="showLoading">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
        </div>
    </div>

    <div class="row" v-if="mode=='full'">
        <div class="col-12 text-center previewPicture">
            <img :src="previewPicture" style="max-height:200px;max-width:100%;" />
        </div>
        <div class="col-12">
            <v-file-input outlined v-model="pictureUpload" id="file" ref="file" :label="label ? label : 'รูปภาพ'" filled prepend-icon="mdi-image" accept=".jpg,.jpeg" hide-details></v-file-input>
            <div class="mt-2 mb-2 uploadResult" v-if="uploadResult" v-html="uploadResult"></div>
            <div class="text-center" v-if="showLoading">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
        </div>
    </div>

    <div class="row" v-if="mode=='button'">

        <div class="col-12  text-center">
            <v-btn color="primary" rounded dark :loading="isSelecting" @click="handleFileImport" small>
               {{label}}
            </v-btn>

            <input ref="uploader" class="d-none" type="file" @change="onFileChanged">
            <div class="mt-2 mb-2 uploadResult" v-if="uploadResult" v-html="uploadResult"></div>
            <div class="text-center" v-if="showLoading">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
        </div>
    </div>

</div>
</template>

<script>
export default {

    components: {

    },
    props: {
        configUploadName: null,
        defaultPicture: null,

        mode: null,

        label: '',
    },

    data: () => ({
        isSelecting: false,
        pictureUpload: null,
        uploadResult: null,
        showLoading: null,

        previewPicture: null
    }),

    computed: {

    },

    watch: {
        defaultPicture() {

            this.setDefaultPicture()

        },
        pictureUpload: function (val) {
            console.log(val)
            let $vm = this
            $vm.showLoading = true
            let formData = new FormData();

            formData.append("file", val);
            formData.append("configUploadName", this.configUploadName);

            console.log(formData);

            var url = "misc/pictureOne?time=" + Math.random();
            this.$API
                .post(url, this.formData(formData), {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(function (res) {
                    $vm.checkApi(res)
                    if (res.data.uploadResult) {
                        let re = res.data.uploadResult
                        if (re.result == 'success') {
                            console.log("SUCCESS!!");
                            $vm.previewPicture = re.previewPicture

                            $vm.$emit('pictureName', re.picture)
                        }

                        $vm.uploadResult = re.msg
                    }

                    $vm.showLoading = null;
                })
                .catch(function (error) {
                    console.log(error);
                });
        }

    },
    methods: {

        handleFileImport() {
            this.isSelecting = true;

            window.addEventListener('focus', () => {
                this.isSelecting = false
            }, {
                once: true
            });

            // Trigger click on the FileInput
            this.$refs.uploader.click();
        },

        onFileChanged(e) {
            this.pictureUpload = e.target.files[0];

        },

        setDefaultPicture() {
            if (!this.defaultPicture) {
                this.previewPicture = 'data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAAAKAAD/4QMtaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjMtYzAxMSA2Ni4xNDU2NjEsIDIwMTIvMDIvMDYtMTQ6NTY6MjcgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDUzYgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RTgxQjk5QzdEOUFGMTFFQjg2NjlENUVCQTY5NTE0NTUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RTgxQjk5QzhEOUFGMTFFQjg2NjlENUVCQTY5NTE0NTUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpFODFCOTlDNUQ5QUYxMUVCODY2OUQ1RUJBNjk1MTQ1NSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpFODFCOTlDNkQ5QUYxMUVCODY2OUQ1RUJBNjk1MTQ1NSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pv/uAA5BZG9iZQBkwAAAAAH/2wCEABQQEBkSGScXFycyJh8mMi4mJiYmLj41NTU1NT5EQUFBQUFBREREREREREREREREREREREREREREREREREREREQBFRkZIBwgJhgYJjYmICY2RDYrKzZERERCNUJERERERERERERERERERERERERERERERERERERERERERERERERERP/AABEIAN4A3gMBIgACEQEDEQH/xABLAAEBAAAAAAAAAAAAAAAAAAAABgEBAAAAAAAAAAAAAAAAAAAAABABAAAAAAAAAAAAAAAAAAAAABEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8ArgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf/Z';
            } else {
                this.previewPicture = this.defaultPicture
            }
        }

    },
    created() {

        this.setDefaultPicture()
    },

};
</script>
